export const tr = {
    api_app: 'uygulama API',
    commander: 'Commander',
    direct_mobile_app: 'Mobil Direct',
    other: 'Otomatik değişiklik',
    web: 'Web arayüzü',
    xls: 'XLS/XLSX'
};
